__turbopack_context__.v({
  "Arrow": "index-module__RgKV9W__Arrow",
  "Avatar": "index-module__RgKV9W__Avatar",
  "AvatarImage": "index-module__RgKV9W__AvatarImage",
  "Container": "index-module__RgKV9W__Container",
  "Description": "index-module__RgKV9W__Description",
  "Plan": "index-module__RgKV9W__Plan",
  "Popup": "index-module__RgKV9W__Popup",
  "Positioner": "index-module__RgKV9W__Positioner",
  "ProfileActions": "index-module__RgKV9W__ProfileActions",
  "ProfilePanel": "index-module__RgKV9W__ProfilePanel",
  "Stack": "index-module__RgKV9W__Stack",
  "Title": "index-module__RgKV9W__Title",
  "Viewport": "index-module__RgKV9W__Viewport",
});
